import { render } from "./PrincipalComponent.vue?vue&type=template&id=570da648&scoped=true"
import script from "./PrincipalComponent.vue?vue&type=script&lang=js"
export * from "./PrincipalComponent.vue?vue&type=script&lang=js"

import "./PrincipalComponent.vue?vue&type=style&index=0&id=570da648&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570da648"]])

export default __exports__